import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/common.service';
import { HttpService } from 'src/app/core/services/http.service';
import { apiUrls } from 'src/app/core/services/urlList/apiUrls';

@Component({
  selector: 'app-share-details',
  templateUrl: './share-details.component.html',
  styleUrls: ['./share-details.component.scss']
})
export class ShareDetailsComponent implements OnInit {
  email:any
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private comm: CommonService,
    private api: HttpService,
    private formBuilder: FormBuilder,
    private urlList: apiUrls,
    private dialog: MatDialogRef<ShareDetailsComponent>
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    
  }
  submit() {
    if (!this.email || !this.email.trim()) {
      this.comm.onErrorToaster('Please enter email');
      return;
    }
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(this.email.trim())) {
      this.comm.onErrorToaster('Please enter a valid email');
      return;
    }

    let data = {
      id: this.data,
      isSendDetails: true,
      email: this.email.trim(),
    };
    this.api.post(this.urlList.sendDeatils, data).subscribe((res: any) => {
      if (res['response']['success']) {
        this.comm.onSuccessToaster('Project details shared successfully');
        this.dialog.close('yes');
      }
    });
  }
  cancel(){
    this.dialog.close("no")
  }
}
